import { LogLevel } from '@azure/msal-browser'

import type { Configuration } from '@azure/msal-browser'

// Config object to be passed to Msal on creation
export const msalConfig:Configuration = {
  auth: {
    // We will fill the clientId value in msalUtils
    clientId: '',
    // Go back to the originating page before redirect to login happened
    navigateToLoginRequestUrl: true
  },
  cache: {
    // 'cacheLocation' configures where your cache will be stored.'localStorage' is preferred.
    // Alternative is 'sessionStorage'
    cacheLocation: 'localStorage',
    storeAuthStateInCookie: false // Set this to 'true' if you are having issues on IE11 or Edge
  },
  system: {
    // iframeHashTimeout. See: https://kksimplifies.com/msal-broswer-browserautherror/
    iframeHashTimeout: 10000,

    loggerOptions: {
      loggerCallback: (level, message, containsPii) => {
        if (containsPii) {
          return
        }
        switch (level) {
          case LogLevel.Error:
            console.error(message)
            return
          case LogLevel.Info:
            // console.info(message)
            return
          case LogLevel.Verbose:
            // console.debug(message)
            return
          case LogLevel.Warning:
            console.warn(message)
            // return
        }
      }
    }
  }
}
